import { type RenderMark } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const bold: RenderMark[string] = (text) => <strong>{text}</strong>
